import { FormControl, TextField, Button, MenuItem, Select, InputLabel } from '@mui/material'
import React, { useEffect, useState, useMemo } from 'react'
import _, { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { MoreHorizOutlined } from '@mui/icons-material';
import WorkflowSessionModal from '../../ItemProperties/WorkflowSessionModal';
import SmartPasswordField from '../../../commonComponents/SmartPasswordField';

const GoogleCloudStorage = ({ 
    connectionDetails, 
    handleBodyContent, 
    direction,
    repoPDC = {}, 
    useConnection, 
    disableControl = false, 
    screen = '', 
}) => {
  const { t } = useTranslation();
  const [projectId, setProjectId] = useState('');
  // const [clientId, setClientId] = useState('');
  // const [clientSecret, setClientSecret] = useState('');
  const [credentialsJson, setCredentialsJson] = useState('');
  const [bucketName, setBucketName] = useState('');
  const [objectName, setObjectName] = useState('');
  const [returnData, setReturnData] = useState('METADATA');
  const [content, setContent] = useState(null);
  const [valueLabel, setValueLabel] = useState("");
  const [workflowSessionModal, setWorkflowSessionModal] = useState({
      open: false,
      isFirstTime: false,
  });

  const workflowMappings = {
      [t("LBL_PROJECT_ID")]: {
          stateSetter: setProjectId,
          key: "PROJECT_ID",
          value: projectId,
      },
      // [t("LBL_CLIENT_ID")]: {
      //     stateSetter: setClientId,
      //     key: "CLIENT_ID",
      //     value: clientId,
      // },
      // [t("LBL_CLIENT_SECRET")]: {
      //     stateSetter: setClientSecret,
      //     key: "CLIENT_SECRET",
      //     value: decryptString(clientSecret || "", process.env.REACT_APP_SECRET_KEY2),
      // },
      [t("LBL_CREDENTIALS_JSON")]: {
          stateSetter: setCredentialsJson,
          key: "CREDENTIALS_JSON",
          value: credentialsJson,
      },
      [t("LBL_BUCKET_NAME")]: {
          stateSetter: setBucketName,
          key: "BUCKET_NAME",
          value: bucketName,
      },
      [t("LBL_OBJECT_NAME")]: {
          stateSetter: setObjectName,
          key: "OBJECT_NAME",
          value: objectName,
      },
  };

  const valuesHandler = (value) => {
      if (workflowMappings[valueLabel]) {
          const { stateSetter, key } = workflowMappings[valueLabel];
          stateSetter(value);
          onInputChange(key, value);
      }
  };

  const getFontWeight = (control, currentValue, useConnection) => {
      if (!repoPDC) return "normal";
      return repoPDC?.[control] !== currentValue &&
          useConnection === "preDefined"
          ? "bold"
          : "normal";
  };

  const fontWeights = useMemo(() => {
      return {
          projectId: getFontWeight("PROJECT_ID", projectId, useConnection),
          // clientId: getFontWeight("CLIENT_ID", clientId, useConnection),
          // clientSecret: getFontWeight("CLIENT_SECRET", clientSecret, useConnection),
          credentialsJson: getFontWeight("CREDENTIALS_JSON", credentialsJson, useConnection),
          bucketName: getFontWeight("BUCKET_NAME", bucketName, useConnection),
          objectName: getFontWeight("OBJECT_NAME", objectName, useConnection),
          returnData: getFontWeight("RETURN_DATA", returnData, useConnection),
      };
  }, [projectId, credentialsJson, bucketName, objectName, returnData, useConnection, repoPDC]);

  const debouncedContentUpdate = debounce(handleBodyContent, 500);

  const onInputChange = (name, value) => {
    if(['GET_DATA', 'SEND_DATA'].includes(screen)){
        setContent((prev) => ({ add:{ ...prev?.add,  [name]: value} }));
        return;
    }
    setContent((prev) => {
      return { ...prev, [name]: value };
    });
  }

  useEffect(() => {
    if(!_.isEqual(content, connectionDetails)) debouncedContentUpdate(content);
  }, [content]);

  useEffect(() => {
    setProjectId(connectionDetails?.PROJECT_ID || '');
    // setClientId(connectionDetails?.CLIENT_ID || '');
    // setClientSecret(decryptString(connectionDetails?.CLIENT_SECRET || "", process.env.REACT_APP_SECRET_KEY2) || '');
    setCredentialsJson(connectionDetails?.CREDENTIALS_JSON || '');
    setBucketName(connectionDetails?.BUCKET_NAME || '');
    setObjectName(connectionDetails?.OBJECT_NAME || '');
    setReturnData(connectionDetails?.RETURN_DATA || 'METADATA');
    setContent({ ...connectionDetails });
  }, [connectionDetails])

  return (
    <>
      <div style={{ display: "flex", gap: "4px" }}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_PROJECT_ID")}
            type="text"
            value={projectId}
            disabled={disableControl || false}
            inputProps={{
                style: { fontWeight: fontWeights.projectId }
            }}
            onChange={(e) => {
              onInputChange(e.target.name, e.target.value);
              setProjectId(e.target.value);
            }}
            className={"width-100"}
            name={"PROJECT_ID"}
            autoComplete="off"
          />
        </FormControl>
        {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <WorkflowSessionModalButton
                disableControl={disableControl || false}
                label={t("LBL_PROJECT_ID")}
                setWorkflowSessionModal={setWorkflowSessionModal}
                setValueLabel={setValueLabel}
            />
        )}
      </div>

      {/* <div style={{ display: "flex", gap: "4px" }}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_CLIENT_ID")}
            type="text"
            value={clientId}
            disabled={disableControl || false}
            inputProps={{
                style: { fontWeight: fontWeights.clientId }
            }}
            onChange={(e) => {
              onInputChange(e.target.name, e.target.value);
              setClientId(e.target.value);
            }}
            className={"width-100"}
            name={"CLIENT_ID"}
            autoComplete="off"
          />
        </FormControl>
        {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <WorkflowSessionModalButton
                disableControl={disableControl || false}
                label={t("LBL_CLIENT_ID")}
                setWorkflowSessionModal={setWorkflowSessionModal}
                setValueLabel={setValueLabel}
            />
        )}
      </div>

      <div style={{ display: "flex", gap: "4px" }}>
        <SmartPasswordField
          variant="outlined"
          size="small"
          label={t("LBL_CLIENT_SECRET")}
          value={clientSecret}
          disabled={disableControl || false}
          inputProps={{
              style: { fontWeight: fontWeights.clientSecret }
          }}
          onChange={(e) => {
            onInputChange(e.target.name, encryptString(e.target.value, process.env.REACT_APP_SECRET_KEY2));
            setClientSecret(e.target.value);
          }}
          className={"width-100"}
          name={"CLIENT_SECRET"}
          autoComplete="off"
        />
        {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <WorkflowSessionModalButton
                disableControl={disableControl || false}
                label={t("LBL_CLIENT_SECRET")}
                setWorkflowSessionModal={setWorkflowSessionModal}
                setValueLabel={setValueLabel}
            />
        )}
      </div> */}

      <div style={{ display: "flex", gap: "4px" }}>
        <SmartPasswordField
          variant="outlined"
          size="small"
          label={t("LBL_CREDENTIALS_JSON")}
          value={credentialsJson}
          disabled={disableControl || false}
          inputProps={{
            style: { fontWeight: fontWeights.credentialsJson }
          }}
          onChange={(e) => {
            onInputChange(e.target.name, e.target.value);
            setCredentialsJson(e.target.value);
          }}
          className={"width-100"}
          name={"CREDENTIALS_JSON"}
          autoComplete="off"
          multiline
          rows={4}
        />
        {["GET_DATA", "SEND_DATA"].includes(screen) && (
          <WorkflowSessionModalButton
            disableControl={disableControl || false}
            label={t("LBL_CREDENTIALS_JSON")}
            setWorkflowSessionModal={setWorkflowSessionModal}
            setValueLabel={setValueLabel}
          />
        )}
      </div>

      <div style={{ display: "flex", gap: "4px" }}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_BUCKET_NAME")}
            type="text"
            value={bucketName}
            disabled={disableControl || false}
            inputProps={{
                style: { fontWeight: fontWeights.bucketName }
            }}
            onChange={(e) => {
              onInputChange(e.target.name, e.target.value);
              setBucketName(e.target.value);
            }}
            className={"width-100"}
            name={"BUCKET_NAME"}
            autoComplete="off"
          />
        </FormControl>
        {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <WorkflowSessionModalButton
                disableControl={disableControl || false}
                label={t("LBL_BUCKET_NAME")}
                setWorkflowSessionModal={setWorkflowSessionModal}
                setValueLabel={setValueLabel}
            />
        )}
      </div>

      <div style={{ display: "flex", gap: "4px" }}>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_OBJECT_NAME")}
            type="text"
            value={objectName}
            disabled={disableControl || false}
            inputProps={{
                style: { fontWeight: fontWeights.objectName }
            }}
            onChange={(e) => {
              onInputChange(e.target.name, e.target.value);
              setObjectName(e.target.value);
            }}
            className={"width-100"}
            name={"OBJECT_NAME"}
            autoComplete="off"
          />
        </FormControl>
        {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <WorkflowSessionModalButton
                disableControl={disableControl || false}
                label={t("LBL_OBJECT_NAME")}
                setWorkflowSessionModal={setWorkflowSessionModal}
                setValueLabel={setValueLabel}
            />
        )}
      </div>

      {direction === 'IN' && (
        <FormControl className="width-100" size="small">
          <InputLabel id="return-data-label">{t("LBL_RETURN_DATA")}</InputLabel>
          <Select
            labelId="return-data-label"
            value={returnData}
            label={t("LBL_RETURN_DATA")}
            disabled={disableControl || false}
            onChange={(e) => {
              onInputChange('RETURN_DATA', e.target.value);
              setReturnData(e.target.value);
            }}
            style={{ fontWeight: fontWeights.returnData }}
          >
            <MenuItem value="METADATA">{t("LBL_METADATA")}</MenuItem>
            <MenuItem value="CONTENT">{t("LBL_CONTENT")}</MenuItem>
          </Select>
        </FormControl>
      )}

      <WorkflowSessionModal
          valueLabel={valueLabel}
          showAccountData={true}
          showCallingWorkflow={true}
          showSystemData={true}
          showWorkflowSession={true}
          showDateAndTime={true}
          openModal={workflowSessionModal}
          setModalOpen={setWorkflowSessionModal}
          handleClose={() =>
              setWorkflowSessionModal({ open: false, isFirstTime: false })
          }
          initialValue={workflowMappings[valueLabel]?.value}
          inputType={valueLabel === t("LBL_CREDENTIALS_JSON") ? "password" : "text"}
          password={valueLabel === t("LBL_CREDENTIALS_JSON")}
          specialPasswordField={valueLabel === t("LBL_CREDENTIALS_JSON")}
          valuesHandler={(value) => {
              valuesHandler(value);
          }}
      />
    </>
  )
}

export default GoogleCloudStorage

const WorkflowSessionModalButton = ({ setWorkflowSessionModal, label, disableControl, setValueLabel }) => {
    return (
        <Button
            size="small"
            disabled={disableControl || false}
            variant="outlined"
            onClick={() => {
                setValueLabel(label);
                setWorkflowSessionModal({ open: true, isFirstTime: true });
            }}
            sx={{ width: "40px", minWidth: "40px" }}>
            <MoreHorizOutlined fontSize="small" />
        </Button>
    );
};
